module.exports = __webpack_public_path__ + "img/S0.40af57de.jpg";